import Vue from "vue";
import Router from "./services/router";
import Store from "./services/store";
import Axios from "./services/vue-axios";
import moment from "./services/vue-moment";
import { i18n } from "./services/vue-i18n";
import rules from "./services/rules";
import VueMask from "./services/vue-mask";
import Datetime from "./services/vuetify-datetime";
import VueTooltip from "./services/vue-tooltip";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import system from "./modules/system/module";
import user from "./modules/user/module";

// Modules registration
[system, user].forEach(module => {
  if (module.store) {
    Store.registerModule(module.name, module.store);
  }
  if (module.routes) {
    Router.addRoutes(module.routes);
  }
  Store.dispatch(module.name + "/init", null, { root: true });
});

Vue.config.productionTip = false;
export const eventBus = new Vue();

new Vue({
  vuetify,
  router: Router,
  store: Store,
  Axios,
  moment,
  VueMask,
  VueTooltip,
  i18n,
  rules,
  Datetime,
  render: h => h(App)
}).$mount("#app");
